import React, { useState } from "react";
import "../Options.css";
import AnswerComments from "../AnswerComments/AnswerComments";

const EssayResult = ({ result, header, status }) => {
  const [showPopUp, setShowPopup] = useState(false);

  function handlePopUp() {
    setShowPopup(!showPopUp);
  }

  return (
    <div style={{ width: "100%" }}>
      <div className="essay__inputResult">{result.answers}</div>
      {result.is_correct >= 0 && (
        <>
          <div className="fileResult__answerPoint_wrap"></div>
          <div className="fileResult__answerPoint">
            <span
              style={{
                color:
                  result.is_correct >= 70
                    ? "#22C532"
                    : result.is_correct >= 50
                    ? "#f6c71e"
                    : "#FF0000",
              }}
            >
              {result.is_correct}
            </span>{" "}
            баллов
          </div>
        </>
      )}
      {result?.result_comment && (
        <div className="comment-box" onClick={handlePopUp}>
          Комментарий
          {showPopUp && (
            <AnswerComments
              result={result}
              header={header}
              handlePopUp={handlePopUp}
            />
          )}
        </div>
      )}

      {(status === null || result.is_correct === null) && (
        <div>
          <div className="openQuestion__announcement_wrap">
            <div className="openQuestion__announcement">
              <p>Ваш ответ отправлен преподавателю на проверку.</p>
              <p>
                После того, как работа будет проверена, Вы получите уведомление
                в личном кабинете и сможете посмотреть результаты.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default EssayResult;
